<template>
  <div class="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-100 flex items-center justify-center p-6">
    <div class="w-full max-w-xl">
      <div class="rounded-2xl shadow-xl bg-white overflow-hidden border border-orange-100">
        <div class="bg-respina-primary px-6 py-6 text-white">
          <div class="flex items-center gap-3">
            <img :src="logoUrl" alt="Respina" class="h-8 w-auto" />
            <div>
              <h1 class="text-xl font-extrabold leading-tight">Respina Board</h1>
              <p class="text-respina-light text-sm opacity-90">
                Getting your flight board ready…
              </p>
            </div>
          </div>
        </div>

        <div class="p-6">
          <div v-if="error" class="space-y-4">
            <div class="p-4 rounded-xl bg-red-50 border border-red-100 text-red-700 text-sm">
              {{ error }}
            </div>
            <div class="flex justify-end">
              <button
                type="button"
                class="h-11 px-6 bg-respina-primary hover:bg-respina-secondary text-white font-bold rounded-xl transition-all shadow-md hover:shadow-lg disabled:opacity-50"
                :disabled="loading"
                @click="boot"
              >
                Retry
              </button>
            </div>
          </div>

          <div v-else class="flex flex-col items-center text-center gap-4 py-2">
            <div
              class="h-14 w-14 rounded-full border-4 border-orange-100 border-t-white flex items-center justify-center animate-spin"
            >
              <i class="fas fa-plane-departure text-respina-primary text-lg"></i>
            </div>
            <div class="space-y-1">
              <p class="text-gray-800 font-semibold text-sm">Checking geo access and configuration…</p>
              <p class="text-gray-500 text-xs">
                Verifying region access and connecting to the Respina Board API.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logoUrl from "@/assets/respina/logo.png";
import { fetchGeoConfig } from "@/lib/geoConfig";

export default {
  data() {
    return {
      logoUrl,
      loading: false,
      error: null,
    };
  },
  mounted() {
    this.boot();
  },
  methods: {
    async boot() {
      this.error = null;
      this.loading = true;
      try {
        await fetchGeoConfig();
        // isBlocked is for iOS app only; frontend does not block by geo.
        // Always send user to the main board; login is handled lazily (e.g. when favoriting).
        this.$router.replace("/airport-board");
      } catch (e) {
        this.error = e?.message || "Failed to load config";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

